import { ChangeDetectorRef, Component, Input, Renderer2, ViewChild } from '@angular/core';
import { Message, ConfirmationService, ConfirmEventType } from 'primeng/api';
import { DataService } from 'src/app/services/data.service';
import { GlobalConstants } from 'src/app/services/global-constants';
import { PermissionHandlerService } from 'src/app/services/permission-handler.service';
import { DataView } from 'primeng/dataview';
import { ActivatedRoute, Router } from '@angular/router';
import { OrganizationUnit } from 'src/app/misc/interface/organization-unit';
import { data_fields } from 'src/app/misc/interface/data';
import { ExportService } from 'src/app/services/export.service';
import { SerializeService } from 'src/app/services/serialize.service';
import { CryptoService } from 'src/app/services/crypto.service';
import { TemplateFieldsService } from 'src/app/services/templete-fileds.service';

import { TranslatorPipe } from 'src/app/services/translator.pipe';
import { PermissionLoaderService } from 'src/app/services/permission-loader.service';

@Component({
  selector: 'app-search-view',
  templateUrl: './search-view.component.html',
  styleUrls: [
    '../search-result/search-result.component.scss',
    '../data-view/data-view.component.scss',
    '../search-view/search-view.component.scss',
  ],
})
export class SearchViewComponent {
  getLastBreadcrumbId(currentItem: any): any {
    // Check if currentItem and breadcrumbs are defined
    if (currentItem && currentItem.breadcrumbs && currentItem.breadcrumbs.length > 0) {
      // Use slice to get the last item without modifying the original array
      const lastBreadcrumb = currentItem.breadcrumbs.slice(-1)[0];

      // Check if the last breadcrumb has the 'id' property
      if (lastBreadcrumb && lastBreadcrumb.id) {
        return lastBreadcrumb.id;
      }
    }

    // Return a default value or handle the case when the last breadcrumb id is not available
    return 1;
  }
  isLoggedIn = JSON.parse(localStorage.getItem('isLoggedIn') || "false");
  deletePermission: boolean = false;
  displayDialog: boolean = false;
  original_searchOu: any;
  original_searchOu_object: any;
  ouIsStriked: boolean = false;
  ouLoading: boolean = false;
  translator: TranslatorPipe = new TranslatorPipe()
  isLogin = false
  
  params: any = {
    ou: null,
    query: null,
    searchTerm: null,
    data: null,
    page: null
  };

  openSignModal = false

  openDialog() {
    this.displayDialog = true
  }

  onOuSelected() {

    this.displayDialog = false

    if (this.searchQueryObject) {

      this.setSearchOuOnObject();

      let queryParams = { query: this.searchQueryObject };
      this.router.navigate(['/advance-search/result'], { queryParams }).then(() => {
        // Force a full page reload after the route change is complete
        location.reload();
      });
    } else {

      if (this.searchOu) {
        // Encode searchQQuery to make it safe for URLs (web/hex)
        let queryParams = { searchTerm:  encodeURIComponent(this.searchQuery), ou: this.searchOu };
        this.router.navigate(['/search-view'], { queryParams }).then(() => {
          // Force a full page reload after the route change is complete
          location.reload();
        });
      } else {
        let queryParams = { searchTerm:  encodeURIComponent(this.searchQuery) };
        this.router.navigate(['/search-view'], { queryParams }).then(() => {
          // Force a full page reload after the route change is complete
          location.reload();
        });
      }

    }
  }

  translate(key: string) {
    let translator: TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }

  onDialogClose() {
    this.searchOu = this.original_searchOu;
    if (this.searchQueryObject) {
      this.setSearchOuOnObject();
    }
    this.refreshOus()
  }

  AddOuAndSearch(arg0: any) {
    this.searchOu = arg0;
    if (this.searchQueryObject) {
      this.setSearchOuOnObject();
    }
    console.log(arg0)
    this.refreshOus()
  }

  removeOuAndSearch() {
    this.searchOu = null;
    if (this.searchQueryObject) {
      this.setSearchOuOnObject();
    }
    this.refreshOus()
  }

  async itemswithoutou() {
    this.ouLoading = true;
    this.ouIsStriked = true;
    this.searchOu = null;
    if (this.searchQueryObject) {
      this.setSearchOuOnObject();
    }
    // this.searchData(this.searchQuery, false).then(()=> {

    // })
    let data = {}
    if (!this.isLoggedIn) {
      data = this.permissionData
    }

    let res;

    if (this.searchQueryObject) {
      res = await this.getQueryData(this.searchQueryObject, true);
    } else {
      res = await this.dataService.postData('data/textSearch?text=null', { ous: this.permissionService.content, ...data, textPost: this.searchQuery });
      //res = await this.dataService.postData('data/textSearch?text=' + this.searchQuery, { ous: this.permissionService.content, ...data });
    }


    if (res.error) {
      return;
    }
    this.data = res.data;

    if (this.data.length > 0) {
      //this.currentService = null
    }
    this.totalRecords = this.data.length;
    this.first = 0;
    this.rows = 10;


    this.ouLoading = false;

  }

  itemswithou() {
    this.ouLoading = true;
    this.ouIsStriked = false;
    this.searchOu = this.original_searchOu;
    if (this.searchQueryObject) {
      this.setSearchOuOnObject();
    }

    this.searchData(this.searchQuery, false).then(() => {
      this.ouLoading = false;
    })
  }

  updateQueryParams(id: number, type?:string) {
    let queryParams: any = {};

    if(type){
      queryParams.type = type
      //debugger
    } else {
      queryParams.data = id
      //debugger
    }

    console.log("params check 1", id)

    console.log("params check 2", this.params['data'])

    console.log("params check 3", this.params['data'] == id.toString())


    

    // Use merge method to merge the existing query parameters with the new ones
    const updatedParams = { ...this.router.parseUrl(this.router.url).queryParams, ...queryParams };

    console.log("params check 4", queryParams)

    if (this.params['data'] == id.toString()) {
      delete updatedParams.data;
    }

    console.log("params check 5", updatedParams)

    // Navigate to the same route with the updated query parameters
    this.router.navigate(['/search-view'], {
      queryParams: updatedParams
    });
    

    this.updateTotalCount()
  }

  async refreshOus() {
    try {

      this.ouLoading = true;

      var res: any;

      if (this.searchQueryObject) {
        res = await this.getQueryData(this.searchQueryObject, true);
      } else {
        res = await this.getQueryData(this.searchQuery, false);
      }



      if (res.error) {
        return;
      }
      this.data = res.data;

      if (this.data.length > 0) {
        // this.changeCurrent(this.data[0]);
      }
      this.totalRecords = this.data.length;
      this.first = 0;
      this.rows = 10;

      if (this.searchOu) {
        if (this.searchQueryObject) {
          let body = this.cryptoService.decodeObject(this.searchQueryObject);
          if (body && body.extras && body.extras.ou) {
            res = await this.dataService.getData('ou/byId?id=' + body.extras.ou);
          } else {
            res = await this.dataService.getData('ou/byId?id=' + this.searchOu);
          }
        } else {
          res = await this.dataService.getData('ou/byId?id=' + this.searchOu);
        }
        this.uniqueMinistries = res.data;
      } else {
        this.uniqueMinistries = [];
        const seenIds = new Set();

        for (const item of this.data) {
          const ministryId = item.ministry.id;

          // Check if the ministryId has not been seen before
          if (!seenIds.has(ministryId)) {
            seenIds.add(ministryId);
            this.uniqueMinistries.push(item.ministry);
          }
        }

        console.log(this.uniqueMinistries);

        if (this.uniqueMinistries.length == 1) {
          this.searchOu = this.uniqueMinistries[0].id;
          if (this.searchQueryObject) {
            this.setSearchOuOnObject();
          }
          let res;
          if (this.searchQueryObject) {
            let body = this.cryptoService.decodeObject(this.searchQueryObject);
            if (body && body.extras && body.extras.ou) {
              res = await this.dataService.getData('ou/byId?id=' + body.extras.ou);
            } else {
              res = await this.dataService.getData('ou/byId?id=' + this.searchOu);
            }
          } else {
            res = await this.dataService.getData('ou/byId?id=' + this.searchOu);
          }
          this.uniqueMinistries = res.data;
        }
      }

      this.ouLoading = false;
      // this.changeQuery()

    } catch (error) {
      console.log(error);
    }
  }

  siteUrl = GlobalConstants.staticFilesURL;

  addAllnum(arg0: number): number {
    const count = this.data.filter(
      (item) =>
        item.breadcrumbs &&
        item.breadcrumbs.some((crumb: { id: number }) => crumb.id === arg0)
    ).length;

    return count;
  }

  addAll(arg0: number): string {
    const count = this.data.filter(
      (item) =>
        item.breadcrumbs &&
        item.breadcrumbs.some((crumb: { id: number }) => crumb.id === arg0)
    ).length;

    // console.log('ouid', arg0, count);

    return count.toString();
  }

  messages: Message[] = [];

  @ViewChild('dv') dataView!: DataView;

  staticURL = GlobalConstants.staticFilesURL;

  data: any[] = [];

  pages: any[] = [];
  showing: string = '';
  currentPage: number = 1;
  totalPages: number = 0;
  totalRecords: number = 0;

  first: number = 0;
  rows: number = 10;
  sortOrder: number = 1;
  sortField: string = '';
  commentText: string = '';

  //Accordial fields
  editIndex?: number;
  fieldTypes: any[] = []; // Initialize as an empty array
  GlobalConstants = GlobalConstants;
  apilink = GlobalConstants.apiURL;
  editData = '';
  editPermission: boolean = false;
  showCommentModal: boolean = false;
  currentTypeFilter: any = 'all';
  data_types: any[] = [];
  currentService: any;
  skelition: boolean = true;
  fetchingCurrent: boolean = false;
  searchQuery: string = '';
  category_id: any = null;

  currentOu: any;
  currentItem: any;
  ous: OrganizationUnit[] = [];
  searchbarSearchValue: string = '';
  @Input() colors: string[] = [
    '#300a3b',
    '#2a0450',
    '#082f4e',
    '#011941',
    '#110d49',
  ];

  editFlag = false;
  searchOu: any;
  searchQueryObject: any;
  uniqueMinistries: any[] = [];

  permissionData: any;

  permissionHideFieldsForInvester: any;

  constructor(
    private dataService: DataService,
    private route: ActivatedRoute,
    private permissionService: PermissionHandlerService,
    private exportService: ExportService,
    private serializeService: SerializeService,
    private confirmationService: ConfirmationService,
    private cryptoService: CryptoService,
    private templateService: TemplateFieldsService,
    private router: Router,
    private permissionLoader: PermissionLoaderService,
    private cdr: ChangeDetectorRef
  ) { }

  async ngOnInit() {

    if (localStorage.getItem('isLoggedIn') == 'true') {
      this.isLogin = true
    }

    this.fetchFieldType();

    if (!this.permissionService.isLoggedIn) {
      await this.permissionService.init();
      this.permissionData = { 
        signedArray: this.permissionService.payload.content.signedOus.content, 
        unsignedArray: this.permissionService.payload.content.allOus.content 
      };

      this.permissionHideFieldsForInvester = this.permissionService.payload.templateHide.fields;
    }

    


    this.route.queryParams.subscribe(async (params) => {
      // console.log('THIS IS ALLLLLLL THE PARAMETERSSSS', params);
      this.ngOnInitChild(params, 'MAIN')
      // .then(()=>{
      //   this.currentTypeFilter = params['type']
      //   this.applyTypeFilter(this.currentTypeFilter,true);
      // })

      this.permissionLoader.getState().subscribe(e => {
        if (!e) {
          this.ngOnInitChild(params, 'SUB')
        }
      })

    });

  }


  async ngOnInitChild(params: any, from: string) {
    console.log('FROM C', from)
    if (this.params['ou'] != params['ou'] || this.params['query'] != params['query'] || this.params['searchTerm'] != params['searchTerm']) {
      this.params = params

      this.searchOu = params['ou'];

      this.original_searchOu = params['ou'];

      this.searchQueryObject = params['query'];

      this.searchQuery = params['searchTerm']

      this.currentTypeFilter = params['type'];

      

      await this.getByIdOriginal(this.original_searchOu);

      if (this.searchQuery) {
        await this.searchData(this.searchQuery, false).then(async (e) => {
          await this.setupTypes();
          this.skelition = false;

        });
      }

      if (this.searchQueryObject != null && this.searchQueryObject != undefined) {
        let body = await this.cryptoService.decodeObject(this.searchQueryObject);
        if (body && body.extras && body.extras.ou) {
          this.searchOu = body.extras.ou;
        }
        await this.searchData(this.searchQueryObject, true).then(async (e) => {
          await this.setupTypes();
          this.skelition = false;

        });
      }

      await this.selectinitialdata().then(() => {
        
        this.currentPage = params['page'] ? Number(params['page']) : 1;
        this.changePage(this.currentPage);
      });
     
    }
    if (this.params['data'] != params['data']) {
      this.params = params
      await this.selectinitialdata().then(() => {
        
        this.currentPage = params['page'] ? Number(params['page']) : 1;
        this.changePage(this.currentPage);
      });

    }

    


  }


  async selectinitialdata() {
    let dataSource: any;
    if(this.currentTypeFilter == 'all') {
      dataSource = this.data;
    } else {
      console.log("this.dataView" , this.dataView);
     //debugger;
      dataSource = this.dataView?.filteredValue ? this.dataView.filteredValue : this.dataView?.value;
    }
     

    console.log("dataSource", dataSource);


    // Ensure dataSource is defined before accessing it
    let currntitemCount = dataSource ? dataSource.findIndex((item: any) => item.id == Number(this.params['data'])) : -1;


    let currntitem = await this.data.findIndex((item: any) => item.id == Number(this.params['data']))

    console.log("itemBug index", currntitem)
    console.log("itemBug count", currntitemCount)




    if (this.data[currntitem]) {

      this.changeCurrent(this.data[currntitem]);
      this.createStates(this.data[currntitem]);



      let n = Math.floor(currntitemCount / 10) + 1

      console.log("item page =========>", n)

      this.currentPage = n;
      this.updatePageParam(n);

    }
  }

  ngAfterViewInit() {
    // Initial check if data is already populated
    this.checkDataPopulated();
    
  }

  ngAfterViewChecked() {
    // Check if data is populated after each view check
    this.checkDataPopulated();
  }

  isDataPopulated: boolean = false;

  private checkDataPopulated() {
    if (!this.isDataPopulated && this.dataView && this.dataView.value && this.dataView.value.length > 0) {
      this.isDataPopulated = true;
      this.applyTypeFilter(this.currentTypeFilter,true);
      this.navigateTo();
      this.cdr.detectChanges(); // Ensure that changes are detected and applied
    }
  }

  navigateTo() {
    // Ensure that this.dataView is initialized before trying to call its paginate method
    if (this.dataView && this.dataView.paginate) {
      this.dataView.paginate({
        first: (this.currentPage - 1) * this.dataView.rows,
        rows: this.dataView.rows,
      });
    } else {
      if (this.dataView) {
        console.error("Error: this.dataView.paginate is not defined.");
      } else {
        console.error("Error: this.dataView is not defined.");
      }
    }
  }


  sortByDepth(items: any): any {
    // console.log(items);
    if (items) {
      return items.sort((a: any, b: any) => {
        return b.depth - a.depth;
      });
    } else {
      return [];
    }
  }

  onEditorTextChange($event: any) {
    console.log("===>Test Dataasasjahskj")

  }

  setupTypes() {
    let mymap = new Map();

    var unique = this.data.filter((el) => {
      const item = el.type;
      if (item) {
        const val = mymap.get(item?.name);
        if (val) {
          if (item && item._id && item._id < val) {
            mymap.delete(item.name);
            mymap.set(item.name, item._id);
            return true;
          } else {
            return false;
          }
        }
        mymap.set(item.name, item._id);
        return true;
      } else {
        return false;
      }
    });

    var uniquetypes: any[] = [];
    if (unique.length > 0) {
      unique.forEach((item) => {
        uniquetypes.push(item.type);
      });
    }



    this.data_types = this.dataSorter(uniquetypes);

    console.log('data types', this.data_types);
  }


  dataSorter(dataCounter: any[]): any[] {
    const orderArray = ["الخدمات", "الأسئلة الشائعة"];

    // Sort the dataCounter array
    dataCounter.sort((a, b) => {
      const aIndex = orderArray.indexOf(a.arabic);
      const bIndex = orderArray.indexOf(b.arabic);

      // If both items are in the orderArray, sort based on their order
      if (aIndex !== -1 && bIndex !== -1) {
        return aIndex - bIndex;
      }

      // If only one of the items is in the orderArray, it comes first
      if (aIndex !== -1) {
        return -1;
      }
      if (bIndex !== -1) {
        return 1;
      }

      // If neither item is in the orderArray, sort them by their _id
      return a.arabic.localeCompare(b.arabic);
    });

    return dataCounter; // Return the sorted array
  }

  counter(countertype: string) {
    return this.data.filter((val) => {
      if (val.type?.name == countertype) {
        return true;
      } else {
        return false;
      }
    }).length;
  }

  applyTypeFilter(value: any, initial=false) {

    this.currentItem = null
    this.changeCurrent(this.currentItem);

    if (this.currentTypeFilter != value || initial) {
      this.currentTypeFilter = value;
    } else {
      this.currentTypeFilter = 'all';
    }
    

    // console.log(value);
    if (this.currentTypeFilter == 'all') {
      this.dataView.filter('', 'contains');
    } else {
      this.dataView.filter(value, 'equals');
    }
    this.updateTotalCount();

    //this.currentPage = 1;
    console.log("current page set when type is changed", this.currentPage)
    this.updatePageParam(this.currentPage);

    if(this.currentTypeFilter){
      this.updateQueryParams(1,this.currentTypeFilter);
    }

    
  }

  updateTotalCount() {
    this.totalRecords = this.dataView.totalRecords;
  }

  getFieldType(type: any) {
    const fieldType = this.fieldTypes.find((item: any) => item._id == type);
    return fieldType ? fieldType.name : 'Unknown';
  }



  reasonModal : any = false
  reasonHolder : any = undefined
  reasonError : boolean = false
  deleteFlag : boolean = false

  updateReasonModal(deleteFlag:boolean = false){
    if (
      !this.currentItem.fields.some((field: any) => field.isChecked === true) &&
      this.currentItem.name == this.previousView.name && deleteFlag == false
    ) {
      return;
    }
    this.reasonModal = true
    this.reasonHolder = ''

    if(deleteFlag){
      this.deleteFlag = true
    }

  }


  updateData() {

    this.reasonError = false    

    if(!this.reasonHolder || this.reasonHolder == '') {
      this.reasonError = true
      return
    }

    // for delete
    if(this.deleteFlag){
      this.deleteService()
      return
    }

    // if no filed is checked
    if (
      !this.currentItem.fields.some((field: any) => field.isChecked === true) &&
      this.currentItem.name == this.previousView.name
    ) {
      return;
    }

    let updateLog = {
      status: 'PENDING',
      type: 'EDIT',
      data_type: this.previousView.type._id,
      before: {
        name: this.previousView.name,
        dataview: this.previousView,
      },
      after: {
        name: this.currentItem.name,
        fields: this.currentItem.fields,
      },
      ous: this.currentItem.ous,
      service_id: this.currentItem._id,
      reason : this.reasonHolder
    };

    this.editContent(updateLog).then(() => {
      //set all checks to false
      const updatedFields = this.currentItem.fields.map((field: any) => ({
        ...field,
        isChecked: false,
      }));
      this.currentItem.fields = updatedFields;
      window.location.reload();
    });
  }

  async editContent(data: any) {
    try {
      let res = await this.dataService.postData('content-update/', data);

      if (res.error) {
        return;
      }
      let isOuPermission: boolean =
        await this.permissionService.checkOUPermissionByID(
          'CONTENT_UPDATE_LOGS',
          'r',
          data.ous
        );
      if (
        this.permissionService.hasPermission('CONTENT_APPROVE', 'a') &&
        isOuPermission
      ) {
        //Approving log
        data._id = res.data._id;
        data.status = 'APPROVED';
        let res2 = await this.dataService.postData(
          'content-update/approve',
          data,
          'PUT',
          false
        );
        if (res2.error) {
          this.messages = [
            {
              severity: 'error',
              summary: this.translate('error'),
              detail: res.msg,
            },
          ];
          return;
        }
      }

      window.location.reload();
    } catch (error) {
      console.log(error);
    }
  }

  hasEditPermissionWithType(): boolean {
    const allowedTypes = this.permissionService.extractTags('CONTENT_UPDATE_DATA_TYPE', 'r');
    return allowedTypes.includes(this.currentItem.type._id);
  }

  async checkEditPermission() {
    if (this.currentOu._id != null && this.currentItem._id != undefined) {
      this.editPermission = await this.permissionService.checkOUPermissionByID(
        'CONTENT',
        'u',
        this.currentOu._id
      );
      this.deletePermission = await this.permissionService.checkOUPermissionByID(
        'CONTENT',
        'd',
        this.currentOu._id
      );
    } else {
      this.editPermission = await this.permissionService.checkOUPermission(
        'CONTENT',
        'u',
        this.currentOu.label
      );
      this.deletePermission = await this.permissionService.checkOUPermission(
        'CONTENT',
        'd',
        this.currentOu.label
      );
    }
  }

  hasPermission(flag: string) {
    return this.permissionService.hasPermission('CONTENT', flag);
  }

  hasUnitPermission(unit: string, flag: string) {
    return this.permissionService.hasPermission(unit, flag);
  }

  private async fetchFieldType(): Promise<void> {
    let res = await this.dataService.postData('field-type/get/', {
      active: true,
    });
    // console.log(res.data);
    if (res.error) {
      return;
    }
    this.fieldTypes = res.data;
  }

  handleSearchbarValueChange(val: string) {
    this.searchbarSearchValue = val;
  }

  editDataSave(arg0: string[] | string | undefined) {
    if (arg0) {
      if (Array.isArray(arg0)) {
        var editData = '';
        arg0.forEach((ele) => {
          editData = editData + ' <br> ' + ele;
        });
        this.editData = editData.slice(5);
      } else {
        this.editData = arg0;
      }
    }
  }

  async deleteService() {
    let deleteLog = {
      status: 'PENDING',
      type: 'DELETE',
      data_type: this.previousView.type._id,
      before: {
        name: this.previousView.name,
        dataview: this.previousView,
      },
      ous: this.currentItem.ous,
      service_id: this.currentItem._id,
      reason : this.reasonHolder
    };
    this.confirm({
      message: this.translate('Are you sure you want to do this?'),
      header: this.translate('Confirmation message'),
      icon: 'pi pi-exclamation-triangle',
      action: () => this.editContent(deleteLog),
    });
  }

  async makeComment() {
    if (!this.commentText || this.commentText == '') {
      return;
    }
    try {
      let data = {
        data_id: this.currentItem._id,
        ou: this.currentOu?._id,
        like: true,
        text: this.commentText,
      };
      let res = await this.dataService.postData('comments/', data);
      this.showCommentModal = false;
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.commentText = '';
      this.messages = [
        { severity: 'success', summary: this.translate('success'), detail: res.msg },
      ];
    } catch (error) {
      console.log(error);
    }
  }

  previousView: any;

  async changeCurrent(current: any) {
    if (this.currentService?._id != current?._id) {
      this.currentService = current;
      if (this.currentService) {
        this.fetchingCurrent = true;
        this.currentItem = await this.getOne();
        this.fetchingCurrent = false;
      }
      

      if (this.currentItem) {
        this.currentItem.fields?.sort((a: data_fields, b: data_fields) => {
          if (a.label?.priority && b.label?.priority) {
            return a.label?.priority - b.label?.priority;
          } else {
            return 0;
          }
        });
        
        this.currentItem.breadcrumbs.sort((a: any, b: any) => {
          return b.depth - a.depth;
        });

        //new changes
        //creating deep copy of old old object
        this.previousView = { ...this.currentItem };

        //adding check
        this.currentItem = {
          ...this.currentItem,
          fields:
            this.currentItem?.fields?.map((item: any) => {
              return { ...item, isChecked: false };
            }) || [],
        };

        this.currentItem.fields =
          await this.templateService.fetchTemplateFields(this.currentItem);
        

        if (this.currentOu) {
          if (this.currentOu._id != current.ou) {
            this.currentOu = this.currentItem.parent;
            this.checkEditPermission();
            
          }
        } else {
          this.currentOu = this.currentItem.parent;
          this.checkEditPermission();

        }
      }
    }
  }

  async getQueryData(query: any, isQuery: boolean) {
    let res;
    let data = {}
    if (!this.isLoggedIn) {
      data = this.permissionData
    }
    if (isQuery && query != null && query != undefined) {
      let body = this.cryptoService.decodeObject(query);
      
      if (body && body.extras && body.extras.ou) {
        body.extras.ou = this.searchOu
        res = await this.dataService.postData('data/advance-search', body);
      } else {
        res = await this.dataService.postData('data/advance-search', body);
      }
    } else {
      if (this.searchOu) {

        //let apilink = 'data/textSearch?text=' + query + '&ou=' + this.searchOu

        let apilink = 'data/textSearch?text=null' + '&ou=' + this.searchOu

        if (this.params) {
          apilink = apilink + '&data=' + this.params['data']
        }
        res = await this.dataService.postData(apilink, { ous: this.permissionService.content, ...data, textPost: decodeURI(query) });

      } else {
        if (this.searchQueryObject) {
          let body = this.cryptoService.decodeObject(this.searchQueryObject);
          if (body && body.extras && body.extras.ou) {
            this.searchOu = body.extras.ou
          }
        } else {
          res = await this.dataService.postData('data/textSearch?text=null', { ous: this.permissionService.content, ...data, textPost:  decodeURI(query) });
        }

      }
    }



    if (res.error) {
      return;
    }
    return res;
  }

  async searchData(query: any, isQuery: boolean) {
    try {
      this.skelition = true;
      let res = await this.getQueryData(query, isQuery);

      this.data = res.data;

      this.data.forEach((item: any) => {
        if (item.ministry.id && item.id) {
          item.uniqueid = item.id.toString() + item.ministry.id.toString();
        } else {
          item.uniqueid = "";
        }

      });

      // if (this.data.length > 0) {
      // this.currentItem = null
      // this.changeCurrent(this.currentItem);
      //this.currentService = null
      // }
      this.totalRecords = this.data.length;
      this.first = 0;
      this.rows = 10;

      if (this.searchOu) {
        let res
        if (this.searchQueryObject) {
          let body = this.cryptoService.decodeObject(this.searchQueryObject);
          if (body && body.extras && body.extras.ou) {
            res = await this.dataService.getData('ou/byId?id=' + body.extras.ou);
          } else {
            res = await this.dataService.getData('ou/byId?id=' + this.searchOu);
          }
        } else {
          res = await this.dataService.getData('ou/byId?id=' + this.searchOu);
        }
        this.uniqueMinistries = res.data;
      } else {
        this.uniqueMinistries = [];
        const seenIds = new Set();

        for (const item of this.data) {
          const ministryId = item.ministry.id;

          // Check if the ministryId has not been seen before
          if (!seenIds.has(ministryId)) {
            seenIds.add(ministryId);
            this.uniqueMinistries.push(item.ministry);
          }
        }

        if (this.uniqueMinistries.length == 1) {
          this.searchOu = this.uniqueMinistries[0].id;

          if (this.searchQueryObject) {
            this.setSearchOuOnObject();
          }

          this.searchData(this.searchQuery, false);
        }
      }
    } catch (error) {
      console.log(error);
    }
  }


  setSearchOuOnObject() {
    let body = this.cryptoService.decodeObject(this.searchQueryObject);

    if (body.extras.ou) {
      body.extras.ou = this.searchOu;
    } else this.searchOu = null

    this.searchQueryObject = this.cryptoService.encodeObject(body);

  }

  async getOne() {
    try {
      let res = await this.dataService.getData(
        'data/one/' + this.currentService.id
      );
      if (res.error) {
        return;
      }
      return res.data[0];
    } catch (e) {
      console.log(e);
    }
  }

  changeToNumber(arg0: string): number {
    return Number(arg0);
  }

  goToPage(maxPage: number) {
    // Validate input and navigate to the specified page

    if (this.currentPage >= 1 && this.currentPage <= maxPage) {
      this.dataView.paginate({
        first: (this.currentPage - 1) * this.dataView.rows,
        rows: this.dataView.rows,
      });
    }
  }
  onPageChange(event: any) {
    this.first = event.first;
    this.rows = event.rows;
  }

  moveToLast(reverse: boolean) {
    if (reverse) {
      this.first = 0;
      this.rows = this.dataView.rows;
      this.currentPage = 1;
      this.updatePageParam(1);
      this.dataView.paginate({ first: this.first, rows: this.rows });
    } else {
      const maxPage = Math.ceil(this.totalRecords / this.dataView.rows);
      this.first = (maxPage - 1) * this.dataView.rows;
      this.rows = this.dataView.rows;
      this.currentPage = maxPage;
      this.updatePageParam(maxPage);
      this.dataView.paginate({
        first: this.first,
        rows: this.rows,
      });
    }
  }

  changePage(n: number) {
    const maxPage = Math.ceil(this.totalRecords / this.dataView.rows);
    if (n > 0 && n <= maxPage) {
      // console.log(n, this.currentPage, maxPage);
      this.currentPage = n;
      this.updatePageParam(n);
      this.goToPage(maxPage);
    }
  }

  updatePageParam( n: number) {

    this.params = { ...this.params, page: n };

    console.log("params", this.params)
    
    this.router.navigate(['/search-view'], { queryParams: this.params });
  }

  applyFilterGlobal($event: any, stringVal: any) {
    this.dataView.filter($event.target.value, stringVal);
  }

  changeView(_t29: any) {
    this.updateQueryParams(_t29.id);

    // this.changeCurrent(_t29);
    // this.createStates(_t29);
  }

  async createStates(data: any) {
    try {
      let uid = localStorage.getItem('uid');
      let user_name = localStorage.getItem('username');
      let payload = {
        user: {
          _id: uid,
          name: user_name,
        },
        service_id: data._id,
        keyword: this.searchQuery,
        category_id: data.id,
      };
      let res = await this.dataService.postData('states', payload);
      if (res.error) {
        console.warn('states log not created ...');
      }
    } catch (error) {
      console.log(error);
    }
  }

  checkisImg(arg0: string | undefined): any {
    if (arg0) {
      return /\.(jpg|jpeg|png|gif|svg)/.test(arg0);
    } else {
      return false;
    }
  }

  confirm(parems: any) {
    this.confirmationService.confirm({
      message: parems.message,
      header: parems.header,
      icon: parems.icon,
      acceptLabel: 'نعم',
      rejectLabel: 'لا',
      accept: () => {
        parems.action();
        return true;
      },
      reject: (type: any) => {
        switch (type) {
          case ConfirmEventType.REJECT:
            return false;
          case ConfirmEventType.CANCEL:
            return false;
          default:
            return false;
        }
      },
    });
  }

  copyLinkToClipboard() {
    this.serializeService.copyToClipboard(`${location.host}/data/${this.currentItem.id}`);
    this.messages = [
      { severity: 'success', summary: this.translate('Link copied to clipboard'), detail: "Link copied to clipboard" },
    ]
  }

  modalVisibilities: boolean[] = [];
  // Function to toggle modal visibility for a specific item.
  toggleModal(index: number) {
    this.modalVisibilities[index] = !this.modalVisibilities[index];
  }

  //service grt
  changeCurrentDataItem(dataItem: any, field: any, index: number) {
    field.data = dataItem;
    this.toggleModal(index);
  }

  async getByIdOriginal(original_searchOu: any): Promise<any> {

    let res

    if (this.searchQueryObject) {
      let body = this.cryptoService.decodeObject(this.searchQueryObject);
      if (body && body.extras && body.extras.ou) {
        res = await this.dataService.getData('ou/byId?id=' + body.extras.ou);
      } else {
        res = await this.dataService.getData('ou/byId?id=' + original_searchOu);
      }
    } else {
      res = await this.dataService.getData('ou/byId?id=' + original_searchOu);
    }

    console.log("THIS IS ORGINAL OBJECT", res.data[0])
    this.original_searchOu_object = res.data[0];
  }

  getBacklink(): string {

    if (this.searchQueryObject) {
      return '/advance-search?query=U2FsdGVkX1'
    } else {
      return '/home'
    }
  }

  changeModal(flag:boolean){
    
    this.openSignModal = flag
  }


  async updateFavourite() {
    try {
      let data = this.currentItem.id;
      let res = await this.dataService.postData('data/update-favorite/' + data, {});
      if (res.error) return;
      let favorites = JSON.parse(localStorage.getItem('favoriteData') || '[]');
      const index = favorites.indexOf(data);
      if (index === -1){
         favorites.push(data);
        }
      else {
        favorites.splice(index, 1);
        if(this.searchQuery == 'fav'){
          window.location.reload()
        }
      }
      localStorage.setItem('favoriteData', JSON.stringify(favorites));
      console.log(res.msg);
    } catch (error) {
      console.log(error);
    }
  }

  isFavorite(id: number = this.currentItem.id): boolean {
    let favorites = JSON.parse(localStorage.getItem('favoriteData') || '[]');
    return favorites.includes(id);
  }
  
  

}